exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mar-right {\r\n  margin-right: 10px;\r\n}\r\n\r\n.md-sm-button {\r\n  width: 10px;\r\n  height: 20px;\r\n  line-height: 20px;\r\n  min-height: 20px;\r\n  vertical-align: top;\r\n  font-size: 10px;\r\n  padding: 0 0;\r\n  margin: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/beneficiary-registration/beneficiary-registration.component.css
// module id = ../../../../../src/app/beneficiary-registration/beneficiary-registration.component.css
// module chunks = 0